import React, { useContext, Suspense } from 'react'
import { Routes, Route, Outlet, Navigate } from 'react-router-dom'
import { Layout } from './layouts/Layout'
import { Home } from './pages/home/Home'
import ScrollToTop from './helpers/ScrollToTop'
import config from './config'
import { UserContext } from './context/UserContext'
import { NotFoundPage } from './pages/not-found/NotFound'
import { Loading } from './pages/loading/Loading'

const Docs = React.lazy(() => import('./pages/docs/Docs'))
const DocsSetUp = React.lazy(() => import('./pages/docs/subpages/setup/Setup'))
const Login = React.lazy(() => import('./pages/authentication/login/Login'))
const Signup = React.lazy(() => import('./pages/authentication/signup/Signup'))
const FormList = React.lazy(() => import('./pages/form-list/FormList'))
const Form = React.lazy(() => import('./pages/form/Form'))
const CustomizeForm = React.lazy(() => import('./pages/customize-form/CustomizeForm'))
const Settings = React.lazy(() => import('./pages/settings/Settings'))
const PrivacyPolicy = React.lazy(() => import('./pages/legal/PrivacyPolicy'))
const TermsOfService = React.lazy(() => import('./pages/legal/TermsOfService'))


function AppRouter() {
    return (
        <>
            <ScrollToTop />
            <Suspense fallback={<Loading />}>
                <Routes>
                    <Route path={`/${config.root}`} element={<Layout />}>
                        <Route path="" element={<Home />} />
                        <Route path="docs" element={<Docs />} />
                        <Route path="docs/setup" element={<DocsSetUp />} />
                        <Route path="login" element={<Login />} />
                        <Route path="signup" element={<Signup />} />
                        <Route element={<PrivateRoutes />}>
                            <Route path="forms" element={<FormList />} />
                            <Route path="forms/:id" element={<Form />} />
                            <Route path="forms/:id/customize" element={<CustomizeForm />} />
                            <Route path="settings" element={<Settings />} />
                        </Route>
                        <Route path="terms-of-service" element={<TermsOfService />} />
                        <Route path="privacy-policy" element={<PrivacyPolicy />} />
                        <Route path="*" element={<NotFoundPage />} />
                    </Route>
                </Routes>
            </Suspense>
        </>
    )
}

export default AppRouter;

const PrivateRoutes = () => {
    const currentUser = localStorage.getItem("currentUser")
    const { user } = useContext(UserContext)

    return (
        user || currentUser ? <Outlet /> : <Navigate to={config.root + '/login'} />
    )
}
